<script setup lang="ts">
import {default as templateStore} from "@/store";
import RegistrationPagePcVersion from "@/components/RegistrationPage/PcVersion.vue";
import RegistrationPageMobileVersion from "@/components/RegistrationPage/MobileVersion.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'
import store from "@/store";
import axios from "axios";
import {
    Avatar, BonusApiDataInterface, Container,
    Frame,
    PassApiDataInterface, PassBonus,
    PassProperties,
    Ship
} from "@/components/RegistrationPage/Card/PassProperties";

export default defineComponent({
    name: 'RegistrationPage',

    mounted(): void
    {
        if (store.state.passes.length !== 0) {
            return
        }

        axios
            .get(
                '/api/game-pass/v1/pass-info',
            )
            .then(result => {
                const data = result.data.data

                store.state.passes = data.passList.map((passData: PassApiDataInterface) => new PassProperties(
                    passData.name,
                    passData.code,
                    passData.level,
                    passData.background,
                    passData.secondary_background,
                    passData.title,
                    passData.glow_color,
                    passData.label_color,
                    new Avatar(passData.avatar.image, passData.avatar.name),
                    new Frame(passData.frame.image, passData.frame.name),
                    new Ship(passData.ship.image, passData.ship.name),
                    new Container(passData.container.image, passData.container.name),
                    passData.players_choice,
                    passData.basic_price,
                    passData.discount_price,
                    passData.galacoin_amount,
                    passData.bonuses.map((bonusData: BonusApiDataInterface) => new PassBonus(
                        bonusData.type,
                        bonusData.name,
                        bonusData.description,
                        bonusData.image,
                    ))
                ))

                store.state.prices = data.prices
            })
    },
})
</script>

<template>
    <RegistrationPagePcVersion v-if="templateStore.state.pageSize.width > templateStore.state.mobileVersionThresholdWidth"/>
    <RegistrationPageMobileVersion v-else/>
</template>

<style scoped lang="scss">
</style>
